// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import VueYandexMetrika from 'vue-yandex-metrika'

import messagesRu from 'vee-validate/dist/locale/ru'
import VeeValidate, { Validator } from 'vee-validate'

import { CHECK_USER_AUTH, RESET_ERRORS } from './store/actions.type'
import { PURGE_AUTH } from './store/mutations.type'
import ApiService from './common/api.service'
import ErrorFilter from './common/error.filter'

Vue.use(VeeValidate, {
  classes: true,
  errorBagName: 'validateErrors'
})
Validator.localize('ru', messagesRu)

Vue.config.productionTip = false
Vue.filter('error', ErrorFilter)

ApiService.init()

router.beforeEach((to, from, next) => {
  if (store.getters.isUserAuthenticated) {
    let checks = [store.dispatch(CHECK_USER_AUTH), store.dispatch(RESET_ERRORS)]
    Promise.all(checks).then(next())
  } else {
    if (to.name === 'home' || to.name === 'email-confirm') {
      store.dispatch(RESET_ERRORS).then(next())
    } else {
      store.dispatch(RESET_ERRORS).then(next('/'))
    }
  }
})

store.subscribe((mutation, state) => {
  if (mutation.type === PURGE_AUTH) {
    router.push({name: 'login'})
  }
})

// Vue.use(VueYandexMetrika, {
//   id: 53662153,
//   router: router,
//   env: process.env.NODE_ENV,
//   debug: process.env.NODE_ENV === 'development',
//   scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
//   options: {
//     clickmap: true,
//     trackLinks: true,
//     accurateTrackBounce: true,
//     webvisor: true
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  watch: {

  }
})



// WEBPACK FOOTER //
// ./src/main.js